import { createFileRoute, redirect } from '@tanstack/react-router';
import { getAuthStore } from '../main';
import { SpSidebar } from '../components/Sidebar';
import { Pane } from '@sheridan-prize/ui';
import { CategoryEdit } from '../components/CategoryEdit';

export const Route = createFileRoute('/categories_/$categoryId')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
    const isAuthenticated = getAuthStore().getIsAuthenticated();

    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }

    if (getAuthStore().getUser()?.role !== 'superadmin') {
      throw redirect({ to: '/' });
    }

    await getAuthStore().fetchUserDoc();
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { categoryId } = Route.useParams();

  return (
    <>
      <SpSidebar />
      <Pane tag="main" classes={'sp-main'}>
        <h1>Edit Category</h1>
        <CategoryEdit categoryId={categoryId} />
      </Pane>
    </>
  );
}
